module.exports = __webpack_public_path__ + "img/owasp-logo-white.6bde2f32.svg";